import React from 'react';

import { MachineStateIconContainer } from '../MachineStatesIcon.elements';
import { useBuSettings, useMachineInfo } from 'common/pages/fleetV2/providers';
import { useFleetRouter } from 'common/pages/fleetV2/hooks/useFleetRouter';

import { useDateRange } from 'components';

import { useMachineStateProtein } from 'hooks';
import { processApiData } from 'common/helpers/processApiData';
import {
  mappedStateProtein,
  StateProtein
} from 'components/MachineStatus/utils/BUsMachineStatusMapping';
import { useTranslation } from 'react-i18next';
import { useMachineStatusProtein } from '../../../BreadCrumbs/MachineStatus/hooks/ProteinMachineStatusHook';

const useMachineState = () => {
  const { colors, Icons } = useBuSettings('protein');
  const [{ id }] = useFleetRouter();
  const { timeZone } = useMachineInfo();
  const machineId = id as string;

  const { endTime } = useDateRange().utcTZConvertedISO;
  if (!machineId) return <></>;

  const localStartDatetimeString = endTime;

  const { states } = useMachineStateProtein(machineId, localStartDatetimeString, 30000);

  const cachedData = React.useMemo(
    () =>
      processApiData(states as [], {
        startTimeKey: 'timestamp',
        endTimeKey: 'endTimestamp',
        timeZone: timeZone as string
      }),
    [states]
  );

  const {status: machineConnection} = useMachineStatusProtein();

  const MachineCurrentState: string =
  machineConnection !== 'Offline' && cachedData?.[0]?.name
    ? cachedData[0].name.toString()
    : 'unknown';

  const { t } = useTranslation(['mh']);
  const mappedProteinState: StateProtein = mappedStateProtein(t);
  const stateName = MachineCurrentState && mappedProteinState[MachineCurrentState];
  const state: string = machineConnection !== 'Offline' && stateName
  ? stateName
  : 'unknown';
  const Icon = (Icons && Icons[MachineCurrentState]) || <></>;
  const color = (colors && colors[MachineCurrentState]) || '';

  return {
    state,
    Icon,
    color
  };
};

export const ProteinMachineStateIcon = (): JSX.Element => {
  const { state, color, Icon } = useMachineState() as {
    state: string;
    color: string;
    Icon: JSX.Element;
  };

  return (
    <div className="machine-info-bar__item machine-state">
      Machine State:
      <MachineStateIconContainer className="machine-state-icon" {...{ color }}>
        <span className="label">{state?.toLowerCase()}</span> {Icon}
      </MachineStateIconContainer>
    </div>
  );
};
